
export const socketType = {
    SOCKET_CONNECTED: 'SOCKET_CONNECTED',
    SOCKET_DISCONNECTED: 'SOCKET_DISCONNECTED',
    SOCKET_RECEIVE_MESSAGE: 'SOCKET_RECEIVE_MESSAGE'
};

export default socketType;
